<template>
		<section class="vue-winwheel">
			<div class="container">
				<div class="row align-items-center">
                    <div class="col-md-6 col-sm-12">
						<div class="mobile-container">
							<!-- <h1>Escoge tu Merengón</h1> -->
							<div class="wheel-wrapper">
								<div class="canvas-wrapper">
									<canvas id="canvas" width="310" height="310">
										<!-- <p style="{color: white}" align="center">Sorry, your browser doesn't support canvas. Please try Google Chrome.</p> -->
									</canvas>
								</div>
								<div class="button-wrapper">
									<a class="btn btn-play" href="#" @click.prevent="startSpin()" v-if="!loadingPrize && !wheelSpinning">GIRA</a>
								</div>
							</div>
						</div>
						<!-- <div class="custom-modal modal-mask" id="modalSpinwheel" v-if="modalPrize"> -->
						<div class="custom-modal modal-mask" id="modalSpinwheel">
							<div class="container">
								<a href="" @click.prevent="hidePrize()" class="modal-dismiss">
									<i class="icon_close"></i>
								</a>
								<h2>
									Hora de comer un rico Merengón
								</h2>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-sm-12">
                        <div class="about-image-block wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="1.5s">
                            <!-- <img src="assets/images/aboutus/about01.jpg" class="img-fluid" alt="" /> -->
                            <img id="prizePic"  :src=prizePicture class="img-fluid picture-of-wheel" alt=""/>
						<h1 id="prizeName"> {{displayName}}</h1>
							<router-link tag="button" class="btn-mas" to="/postres">Ver más...</router-link>
                        </div>
                    </div>
				</div>
			</div>
		</section>
</template>


<script>
import * as Winwheel from 'vue-winwheel/Winwheel'
export default {
  name: 'VueWinWheel',
  props:{
		segments:{
			default(){
				return []
			}
		}
  },
  data () {
    return {
      loadingPrize: false,
      theWheel: null,
      modalPrize: false,
      wheelPower: 1,
      wheelSpinning: false,
      prizeName: '...',
	  displayName: '...',
	  prizePictureName: '',
	  prizePicture: 'assets/images/aboutus/misterio.png',
      WinWheelOptions: {
        textFontSize: 14,
        outterRadius: 410,
        innerRadius: 25,
        lineWidth: 8,
        animation: {
          type: 'spinOngoing',
          duration: 0.5
        }
      }
    }
  },
  methods: {
    showPrize () {
      this.modalPrize = true
    },
    hidePrize () {
      this.modalPrize = false
    },
    startSpin () {
      if (this.wheelSpinning === false) {
        this.theWheel.startAnimation()
        this.wheelSpinning = true
        this.theWheel = new Winwheel.Winwheel({
          ...this.WinWheelOptions,
          numSegments: this.segments.length,
          segments: this.segments,
          animation: {
            type: 'spinToStop',
            duration: 5,
            spins: 5,
            callbackFinished: this.onFinishSpin
          }
        })
        // example input prize number get from Backend
        // Important thing is to set the stopAngle of the animation before stating the spin.
        var prizeNumber = Math.floor(Math.random() * this.segments.length) // or just get from Backend
        var stopAt = 360 / this.segments.length * prizeNumber - 360 / this.segments.length / 2 // center pin
        // var stopAt = 360 / this.segments.length * prizeNumber - Math.floor(Math.random() * 60) //random location
        this.theWheel.animation.stopAngle = stopAt
        this.theWheel.startAnimation()
        this.wheelSpinning = false
		// this.hidePrizePic()
      }
    },
    resetWheel () {
      this.theWheel = new Winwheel.Winwheel({
        ...this.WinWheelOptions,
        numSegments: this.segments.length,
        segments: this.segments
      })
      if (this.wheelSpinning) {
        this.theWheel.stopAnimation(false) // Stop the animation, false as param so does not call callback function.
      }
      this.theWheel.rotationAngle = 0 // Re-set the wheel angle to 0 degrees.
      this.theWheel.draw() // Call draw to render changes to the wheel.
      this.wheelSpinning = false // Reset to false to power buttons and spin can be clicked again.
    },
    initSpin () {
      this.loadingPrize = true
            this.resetWheel()
            this.loadingPrize = false
    },
    onFinishSpin (indicatedSegment) {
      this.prizePictureName = indicatedSegment.picture
      this.showPrize()
      this.animatePrize(indicatedSegment.text)
    },
    animatePrize (newName) {
      const img = document.getElementById('prizePic')
      const nameEl = document.getElementById('prizeName')

      // Siempre actualizar los datos pendientes más recientes
      this._pendingName = newName
      this._pendingSrc = 'assets/images/ruleta/' + this.prizePictureName + '.png'

      // Si ya hay una animación en curso (hiding O loading), solo actualizar datos y salir.
      // El pipeline activo leerá _pendingName/_pendingSrc al terminar cada etapa.
      if (this._animating) return
      this._animating = true

      // Etapa 2: cargar imagen y revelar (se llama desde transitionend)
      const loadAndReveal = () => {
        const targetSrc = this._pendingSrc
        const targetName = this._pendingName

        const onLoaded = () => {
          if (this._pendingSrc !== targetSrc) {
            // Los datos cambiaron mientras cargaba → cargar la versión más reciente
            this.prizePicture = this._pendingSrc
            img.addEventListener('load', onLoaded, { once: true })
            img.addEventListener('error', onLoaded, { once: true })
            return
          }
          this.displayName = this._pendingName
          img.classList.remove('prize-hidden')
          nameEl.classList.remove('name-hidden')
          this._animating = false
        }

        if (this.prizePicture === targetSrc) {
          // Misma imagen: no hay evento load, revelar directamente
          this.displayName = targetName
          this.$nextTick(() => {
            img.classList.remove('prize-hidden')
            nameEl.classList.remove('name-hidden')
            this._animating = false
          })
        } else {
          img.addEventListener('load', onLoaded, { once: true })
          img.addEventListener('error', onLoaded, { once: true })
          this.prizePicture = targetSrc
        }
      }

      // Etapa 1: ocultar imagen actual
      img.classList.add('prize-hidden')
      nameEl.classList.add('name-hidden')

      const onTransitionEnd = (e) => {
        if (e.propertyName !== 'transform') return
        img.removeEventListener('transitionend', onTransitionEnd)
        loadAndReveal()
      }
      img.addEventListener('transitionend', onTransitionEnd)
    },
	hidePrizePic() {
		$("#prizePic").fadeTo(5000, 0.0001)
	}
  },
  computed: {},
  updated () {},
  mounted () {
    this._animating = false
    this._pendingName = ''
    this._pendingSrc = ''
    this.initSpin()
    // this.resetWheel()
  },
  created () {},
  watch: {}
}
</script>

<style scoped>
.vue-winwheel {
	text-align: center;
	/* background-image: url('/root/merengon-bavaro-web-tomillo/static/img/obstacle-run/bg-spinner-mobile.svg'); */ /*Producción*/
	background-image: url('/static/img/obstacle-run/bg-spinner-mobile.svg');
	background-size: cover;
	background-position: center bottom;
	background-repeat: no-repeat;
}
.vue-winwheel h1 {
	/* color: #b32656; */
	color: #2e5842;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	font-size: 36px;
	line-height: 90px;
	letter-spacing: 4px;
	margin: 0;
	transition: opacity 0.18s ease, transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	transform: translateY(0);
	opacity: 1;
}
.vue-winwheel h1.name-hidden {
	opacity: 0;
	transform: translateY(15px);
}
.vue-winwheel h2 {
	margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content {
	width: calc(100vw - 30px);
	padding-top: 52px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content h2 {
	text-transform: uppercase;
	/* color: #b32656; */
	color: #2e5842;
	margin-bottom: 16px;
	margin-top: 0;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	font-size: 18px;
	letter-spacing: 1.1px;
	margin: 0;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	font-size: 14px;
	color: black;
	text-align: center;
	line-height: 25px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content p strong {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss {
	top: 12px;
	right: 12px;
}
.vue-winwheel #modalSpinwheel.custom-modal .content-wrapper .content .modal-dismiss i.icon_close {
	font-size: 30px;
	color: #da2a52;
}
.vue-winwheel canvas#canvas {
	position: relative;
}
.vue-winwheel .canvas-wrapper {
	position: relative;
}
.vue-winwheel .canvas-wrapper:after {
	content: '';
	display: block;
	width: 42px;
	/*background: #c4376f;*/
	background: #2e5842;
	height: 42px;
	position: absolute;
	left: calc(50% - 25px);
	margin: auto;
	border-radius: 100%;
	top: calc(50% - 29px);
	border: 5px solid white;
	box-sizing: content-box;
}
.vue-winwheel .canvas-wrapper:before {
	content: '';
	display: block;
	width: 310px;
	background: #0f0f0f;
	height: 310px;
	position: absolute;
	left: 0;
	right: 0;
	margin: 0 auto;
	border-radius: 100%;
	top: 0;
}
.vue-winwheel .wheel-wrapper {
	position: relative;
}
.vue-winwheel .wheel-wrapper:before {
    content: '';
    width: 62px;
    height: 47px;
    position: absolute;
    top: -10px;
    left: calc(50% - 31px);
    right: 0;
    display: block;
    z-index: 10;
    /* background-image: url('/root/merengon-bavaro-web-tomillo/src/spinner-marker.svg');*/ /*Producción*/
    background-image: url('/src/spinner-marker.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.vue-winwheel .wheel-wrapper .button-wrapper {
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 231px;
	height: 118px;
}
.vue-winwheel .wheel-wrapper .btn.btn-play {
	padding: 0 58px !important;
	background: #EC6719;
	height: 40px;
	line-height: 40px;
	color: white;
	font-weight: bold;
	text-decoration: none;
	border-radius: 40px;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	letter-spacing: 2px;
}
.picture-of-wheel {
    	height: 408px;
		border-radius: 30px;
		transition: opacity 0.18s ease, transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
		transform: scale(1) rotate(0deg);
		opacity: 1;
}
.picture-of-wheel.prize-hidden {
		opacity: 0;
		transform: scale(0.4) rotate(-10deg);
}
.btn-mas {
	padding: 0 15px !important;
    background: #EC6719;
    height: 40px;
    line-height: 40px;
    color: white;
    font-weight: bold;
	border: white;
    border-radius: 40px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>